<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Filtreler</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <TurFiltreDialog @update-filter="updateFilter"/>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="vazgec()">{{ $t('Cancel') }}</v-btn>

            <div v-show="m === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deletemastertur()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>


            </div>
            <div v-show="k === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t("save_button") }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t("save_button") }}</span>
              </v-tooltip>


            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{ 'Tur Ara' }}</v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
    </v-layout>
    <v-container fluid>
      <v-form ref="muhasebehesabagore" v-model="valid">
        <v-layout row wrap="">
          <v-flex xs12 sm6 md2>
            <tarihcomp :etiket="$t('Starting-Date')" v-bind:defaultvalue="'ok'"
              v-model="MasterTurSearchParams.BaslangicTarihi" :rules="[(v) => !!v || $t('Please-select-a-date')]">
            </tarihcomp>
          </v-flex>

          <v-flex xs12 sm6 md2>
            <tarihcomp :etiket="$t('Finishing-Date')" :rules="[(v) => !!v || $t('Please-select-a-date')]"
              v-model="MasterTurSearchParams.BitisTarihi" v-bind:defaultvalue="'ok'">
            </tarihcomp>
          </v-flex>
          <v-flex xs9 md6 sm12>
            <v-select label="Ürün Grubu" item-text="Aciklama" item-value="Id" :items="urungruplari"
              v-model="MasterTurSearchParams.UrunGrubuId"></v-select>

          </v-flex>
          <v-flex xs9 md6 sm12>
            <v-select label="Kategori" item-text="Aciklama" item-value="Id" :items="kategoriler"
              v-model="MasterTurSearchParams.KategoriId"></v-select>
          </v-flex>

          <v-flex>
            <v-layout>
              <v-btn @click="MasterTurSearch()" color="info" fab small="" dark>
                <v-icon>search</v-icon>
              </v-btn>

              <v-btn @click="dialog = true" small="" color="info" fab dark>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>

    <v-layout v-for="tur in masterTurResult" row="" wrap>

      <v-flex pa-2 xs12 sm12 md12>
        <v-hover>
          <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">
            <v-list two-line="">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-card flat class="black--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex sm12 md2 justify-start>
                            <v-img :src="tur.MasterTurResimler.Resimler[0].url" height="120px" width="100%" contain>
                            </v-img>
                          </v-flex>
                          <v-flex sm12 md3 class="my-auto text-xs-center">
                            <span class="title" color="blue">{{ tur.TurAdi }}</span>
                          </v-flex>
                          <v-flex sm12 md3 class="my-auto text-xs-center">
                            Başlangıç: {{ formatDate(tur.MinTarih) }} </br>Bitiş: {{ formatDate(tur.MaxTarih) }} </br>
                            {{ tur.Gece }} Gece - {{ tur.Gunduz }} Gün
                          </v-flex>
                          <v-flex sm12 md2 class="my-auto text-xs-center">
                            Başlangıç Fiyat: </br><span bold> {{ tur.MinFiyat }} {{ tur.Doviz }} </span> </br>
                            <v-divider></v-divider> </br><v-btn flat>{{tur.PaketSayisi}} Alt Tur</v-btn>
                          </v-flex>

                          <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                            <v-btn @click="gitTurDetay(tur)" color="success">İncele
                              <v-icon right dark>search</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>

            </v-list>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>


    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{ $t('Close') }}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
import auth from '../../../api/auth'
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import tarihcomp from "../customcomp/tarihim";
import tools from '../coper/tools';
import TurFiltreDialog from './arama/turFiltreDialog.vue';
export default {
  data() {
    return {
      validbanka: true,
      passwordRules: [
        v => !!v || this.$t('This-space-cannot-left-blank'),
        v => (v && v.length < 5) || this.$t('Maximum-4-characters')
      ],
      sayfayetki: {
        Screen: true,
        Update: true,
        Save: true,
        Delete: true,
        Status: true,
        Message: null,
        islem: 0,
      },
      headers: [{
        text: 'Tur Kodu',
        value: 'TurKodu'
      },
      {
        text: 'Tur Adı',
        value: 'TurAdi'
      },
      {
        text: 'Ürün Grubu',
        value: 'UrunGurubuAdi'
      },
      {
        text: 'Kategori',
        value: 'KategoriAdi'
      },
      {
        text: 'Gündüz',
        value: 'Gunduz'
      },
      {
        text: 'Gece',
        value: 'Gee'
      },
      {
        text: 'Notlar',
        value: 'Notlar'
      }

      ],
      loading: false,
      color: 'orange darken-4',
      items: [],
      search3: '',
      search: null,
      select: [],
      selected: '',
      kategoriler: [],
      urungruplari: [],
      m: false,
      k: false,
      dialog: false,
      MasterTurSearchParams: {
        TurKodu: "",
        TurAdi: "",
        Gece: 0,
        Gunduz: 0,
        Aktif: true,
        KategoriId:0,
        UrunGrubuId:0,
        Kategori: {
          id: "0",
          kod: null,
          isim: null,
          tip: 0,
          intField: null,
        },
        UrunGrubu: {
          id: "0",
          kod: null,
          isim: null,
          tip: 0,
          intField: null,
        },
        Kontenjan: 0,
        tumSirketler: false,
        sayfaAdi: null,
        Doviz: 'EUR',
        BaslangicTarihi: new Date(2024, 1, 1),
        BitisTarihi: new Date(),
      },
      cari: '',
      masterTurResult: [],
      state: [],
      dialogfiltre: false,
      dialog_baslik: '',
      codegorunum: true,
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      text1: '',
      bankakod: '',
      bankaadi: '',
      progress: false,
      dictionary: {
        custom: {
          bankakod: {
            required: () => this.$t('This-space-cannot-left-blank'),
            max: () => this.$t('Must-least-4-digits'),
          },
          bankaadi: {
            required: () => this.$t('This-space-cannot-left-blank'),
          }
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path
    })
  },
  watch: {
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.MasterTurSearch();
    this.geturungruplari();
    this.getkategoriler();
    // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
  },
  methods: {
    yeniekle() {
      var url = '#/pakettur/masterpaketislem/'
      window.open(url, '_self')
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("tr-TR", {
        day: "numeric", // Günü gösterir
        month: "long",  // Ay adını gösterir (örnek: Aralık)
        year:"numeric"
      });
    },
    gitTurDetay(val) {
      var url = '#/pakettur/turdetay?id=' + val.Id;
      window.open(url, '_self')
    },
    Getir(v) {
      this.k = false
      this.m = true
      this.codegorunum = false
      this.dialog = true
      this.dialog_baslik = this.$t('Update')

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    },
    async MasterTurSearch() {
      this.loadingvmodel = true;

      try {
        const response = await tools.http_post(this, "MasterTurSearch", this.MasterTurSearchParams);
        if (response.body.Status === true) {
          this.masterTurResult = response.body.data;
          for (const masterTur of this.masterTurResult) {
            if (
              masterTur.MasterTurResimler &&
              masterTur.MasterTurResimler.Resimler &&
              masterTur.MasterTurResimler.Resimler.length > 0
            ) {
              const url = await this.getImage(masterTur.MasterTurResimler.Resimler[0].FileCode);
              if (url !== "hata") {
                masterTur.MasterTurResimler.Resimler[0].url = url;
              } else {
                console.warn(`Resim yüklenirken hata oluştu: ${fileCode}`);
              }
            }
          }
          this.loadingvmodel = false;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      } catch (error) {
        this.text1 = "Hata Oluştu, tekrar deneyiniz";
        this.snackbar = true;
        this.loadingvmodel = false;
      }
    },

    async getImage(resim) {
      const params = {
        FileCode: resim,
      };

      try {
        const response = await tools.http_post(this, "BinaryFileLoadBase64", params);
        if (response.body.Status === true) {
          const fileBase64 = response.body.data.imageBase64;
          return URL.createObjectURL(this.base64toBlob(fileBase64, "image/jpeg"));
        } else {
          return "hata";
        }
      } catch (error) {
        console.error("Ağ hatası:", error);
        return "hata";
      }
    },

    base64toBlob(base64Data, contentType = "application/octet-stream") {
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      return new Blob([byteNumbers], { type: contentType });
    },
    getkategoriler() {
      let params = {
        TanitimTip: 9,
      };

      tools.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {

            this.kategoriler = response.body.data;

          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
          this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    geturungruplari() {
      let params = {
        TanitimTip: 10,
      };

      tools.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.urungruplari = response.body.data;

          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
          this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    updateFilter(val){
      this.MasterTurSearchParams = {...this.MasterTurSearchParams,...val}
      console.log(this.MasterTurSearchParams,"searchparams")
    },
    deletemastertur: deletemastertur,
    masterturekle: masterturekle,
    Kaydet: Kaydet,
    guncelle: guncelle,
    vazgec: vazgec
  },
  beforeMount: beforeMount,
  components: {
    yetkidialog,
    tarihcomp,
    TurFiltreDialog
  },
  vazgec: vazgec
}


function vazgec() {
  this.dialog = false
  this.search = ''

}


function Kaydet() {
  if (this.$refs.formbanka.validate()) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
  }
}
function masterturekle() {

  this.dialog = true
  this.MasterTur = {}
  this.dialog_baslik = 'Ekle'
  this.m = false
  this.k = true
  this.codegorunum = true
  this.$validator.reset()

}

function beforeMount() {

}

function deletemastertur() {
  if (window.confirm('Seçili Turu silmek istediğinizden emin misiniz?')) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


  }
}

function guncelle() {

}

</script>

<style></style>